import { gsap } from "gsap";
import { prefersReducedMotion, hasFinePointer } from "./motion-utils.js";

// A small decorative cursor (dot + trailing ring). It is strictly additive:
// the browser's real cursor/focus behavior is untouched for keyboard and
// touch users, and this never becomes the only way to tell what's
// interactive (hover targets keep their own visual states regardless).
export function initCursor() {
  if (prefersReducedMotion() || !hasFinePointer()) return;

  const dot = document.createElement("div");
  dot.className = "cursor-dot";
  dot.setAttribute("aria-hidden", "true");

  const ring = document.createElement("div");
  ring.className = "cursor-ring";
  ring.setAttribute("aria-hidden", "true");

  document.body.append(dot, ring);

  const moveDot = gsap.quickTo(dot, "x", { duration: 0.05, ease: "power1.out" });
  const moveDotY = gsap.quickTo(dot, "y", { duration: 0.05, ease: "power1.out" });
  const moveRing = gsap.quickTo(ring, "x", { duration: 0.35, ease: "power3.out" });
  const moveRingY = gsap.quickTo(ring, "y", { duration: 0.35, ease: "power3.out" });

  window.addEventListener("pointermove", (e) => {
    moveDot(e.clientX);
    moveDotY(e.clientY);
    moveRing(e.clientX);
    moveRingY(e.clientY);
  });

  const interactiveSelector = 'a, button, [role="button"], input, textarea, select, [data-cursor-active]';

  document.addEventListener("pointerover", (e) => {
    if (e.target.closest?.(interactiveSelector)) {
      document.body.setAttribute("data-cursor", "active");
    }
  });
  document.addEventListener("pointerout", (e) => {
    if (e.target.closest?.(interactiveSelector)) {
      document.body.removeAttribute("data-cursor");
    }
  });

  document.body.setAttribute("data-cursor-ready", "true");

  // If the pointer type changes to coarse (e.g. hybrid device switches to
  // touch), bail out cleanly rather than leaving a stuck cursor.
  window.matchMedia("(pointer: coarse)").addEventListener?.("change", (e) => {
    if (e.matches) {
      document.body.removeAttribute("data-cursor-ready");
      dot.remove();
      ring.remove();
    }
  });
}
